import { Component, Input } from '@angular/core';
import _ from 'lodash';
import { AssignablePersonSummaryWritable } from '../../models/evaluation/assignablePersonSummaryWritable';

@Component({
  selector: 'checkbox-group',
  templateUrl: 'checkbox-group.component.html',
  styleUrls: ['checkbox-group.component.scss'],
  standalone: false
})
export class CheckboxGroup {
  toggleValue: string = 'positionTitle';
  @Input() set collection(value) {
    if (_.difference(value, this._collection).length > 0) {
      this._collection = value;

      if (this._groupKeyName !== '') {
        this.buildPositionGroupCollection();
      }
    }
  }
  get collection(): any[] {
    return this._collection;
  }
  @Input()
  keyName: string;
  @Input()
  isDisabled: boolean;
  @Input()
  displayValue: any;
  @Input()
  showSelectAll: boolean = true;
  @Input() set groupKeyName(value) {
    this._groupKeyName = value;
  }
  _collection: any[];
  _groupKeyName = '';
  _groupMap = new Map<string, AssignablePersonSummaryWritable[]>();

  get selectAll(): boolean {
    let activeItems = _.filter(this.collection, function (item) {
      return !item.disabled;
    });
    return _.every(activeItems, this.keyName);
  }
  get selectAllDisabled(): boolean {
    return _.every(this.collection, { disabled: true });
  }

  set selectAll(value: boolean) {
    this.selectAllClicked(value);
  }

  selectAllClicked(value: boolean) {
    if (!this.showSelectAll) return;

    var keyName = this.keyName;
    _.each(this.collection, function (item) {
      if (item.disabled == false) {
        item[keyName] = value;
      }
    });
  }

  getDisplayValue(item) {
    return typeof this.displayValue === 'string'
      ? item[this.displayValue]
      : this.displayValue(item);
  }

  buildPositionGroupCollection(): void {
    const currentGroupMap = new Map<string, AssignablePersonSummaryWritable[]>();
    const currentGroupKeyState = new Map<string, boolean>();

    if (this.collection) {
      this.collection.forEach((person) => {
        if (currentGroupMap.has(person.positionTitle)) {
          const currentArray = currentGroupMap.get(person.positionTitle);
          currentArray.push(person);
        } else {
          const currentArray = [person];
          currentGroupMap.set(person.positionTitle, currentArray);
          currentGroupKeyState.set(person.positionTitle, false);
        }
      });
    }

    this._groupMap = currentGroupMap;
  }

  buildStatusGroupCollection(): void {
    const currentGroupMap = new Map<string, AssignablePersonSummaryWritable[]>();
    const currentGroupKeyState = new Map<string, boolean>();

    if (this.collection) {
      this.collection.forEach((person) => {
        if (currentGroupMap.has(person.status)) {
          const currentArray = currentGroupMap.get(person.status);
          currentArray.push(person);
        } else {
          const currentArray = [person];
          currentGroupMap.set(person.status, currentArray);
          currentGroupKeyState.set(person.status, false);
        }
      });
    }

    this._groupMap = currentGroupMap;
  }

  onChange(event) {
    if (event.value == 'positionTitle') {
      this.buildPositionGroupCollection();
    } else {
      this.buildStatusGroupCollection();
    }
  }

  getGroupMapKeys(): string[] {
    const result = [...this._groupMap.keys()];
    return result;
  }

  getGroupMapValuesForKey(key: string): AssignablePersonSummaryWritable[] {
    return this._groupMap.get(key);
  }

  getGroupDisabledStateForKey(key: string): boolean {
    return _.every(this._groupMap.get(key), { disabled: true });
  }

  getGroupKeyStateForKey(key: string): boolean {
    return this.selectAll || _.every(this._groupMap.get(key), this.keyName);
  }

  setGroupKeyStateForKey(key: string, state: boolean): void {
    const entriesInGroup = this._groupMap.get(key);
    var keyName = this.keyName;
    _.each(entriesInGroup, function (item) {
      if (item.disabled == false) {
        item[keyName] = state;
      }
    });
  }
}
